import React, { useMemo } from 'react';
import { v4 as uuid } from 'uuid';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import FormField from '../../../atoms/Form/Field/FormField';
import Switch from '../../../atoms/Switch/Switch';

const SwitchFieldRender = ({
  input,
  label,
  placeholder,
  id,
  meta: { error, touched },
  disabled,
}) => (
  <Switch
    {...input}
    error={!!(touched && error)}
    label={label}
    id={id}
    block
    placeholder={placeholder}
    disabled={disabled}
  />
);

SwitchFieldRender.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  checked: PropTypes.bool,
  meta: PropTypes.shape({
    error: PropTypes.any,
    touched: PropTypes.bool,
  }),
  id: PropTypes.string,
  disabled: PropTypes.bool,
};

const SwitchField = ({
  name,
  label,
  information,
  informationCanWrap = false,
  ...props
}) => {
  const id = useMemo(() => uuid(), [name]);
  return (
    <FormField
      label={label}
      name={name}
      htmlFor={id}
      information={information}
      inline
      reverse
      clickableLabel
      informationCanWrap={informationCanWrap}
    >
      <Field name={name} component={SwitchFieldRender} id={id} {...props} type="checkbox" />
    </FormField>
  );
};

SwitchField.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  information: PropTypes.string,
  informationCanWrap: PropTypes.bool,
};

export default SwitchField;
